import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Floating WhatsApp button, sticky bottom-right on every page.
 * Opens a prefilled chat with Move Van Ltd.
 */
const DEFAULT_MESSAGE = encodeURIComponent(
  "Hi Move Van Ltd — I'd like to get a quote / check availability. Thanks!"
);
const WA_URL = `https://wa.me/447985291097?text=${DEFAULT_MESSAGE}`;

const WhatsAppFab = () => {
  const { pathname } = useLocation();
  if (/^\/(driver|admin)/.test(pathname)) return null;
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Move Van Ltd on WhatsApp"
      title="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-[60] group hidden sm:flex items-center gap-2 pl-3 pr-4 py-3 rounded-full shadow-lg bg-[#25D366] hover:bg-[#1ebc5a] text-white font-semibold transition-all hover:scale-[1.03] active:scale-95"
      style={{ boxShadow: '0 10px 28px rgba(37,211,102,0.45)' }}
    >
      <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-white/15">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-60 animate-ping" />
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-5 h-5 relative"
          aria-hidden="true"
        >
          <path d="M20.52 3.48A11.78 11.78 0 0 0 12.06 0C5.5 0 .2 5.3.2 11.86a11.76 11.76 0 0 0 1.61 5.95L0 24l6.35-1.66a11.84 11.84 0 0 0 5.7 1.45h.01c6.56 0 11.86-5.3 11.86-11.86 0-3.17-1.23-6.14-3.4-8.45zM12.06 21.5h-.01a9.63 9.63 0 0 1-4.9-1.34l-.35-.21-3.77.99 1.01-3.67-.23-.38a9.6 9.6 0 0 1-1.47-5.03c0-5.3 4.32-9.62 9.63-9.62 2.57 0 4.98 1 6.79 2.82a9.55 9.55 0 0 1 2.82 6.8c0 5.31-4.32 9.64-9.52 9.64zm5.52-7.21c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.76.97-.93 1.17c-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.44-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.1 4.5.71.31 1.27.5 1.7.64.72.23 1.37.2 1.88.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
        </svg>
      </span>
      <span className="hidden sm:inline text-sm">WhatsApp us</span>
    </a>
  );
};

export default WhatsAppFab;
